// extracted by mini-css-extract-plugin
export var button = "_c2-2";
export var iconWrapper = "_c2-0";
export var investigatingIcon = "_c2-1";